import { useEffect, useRef } from "react";
import site, { withBase } from "../../siteInfo";
import { gsap, prefersReducedMotion } from "../../motion/gsap";

const Home = () => {
  const root = useRef(null);

  useEffect(() => {
    const el = root.current;
    if (!el || prefersReducedMotion()) return undefined;

    const ctx = gsap.context(() => {
      const tl = gsap.timeline({ defaults: { ease: "power3.out" } });
      tl.from(".hero-copy > *", { y: 28, opacity: 0, duration: 0.85, stagger: 0.07 })
        .from(
          ".hero-frame",
          { clipPath: "inset(14% 10% 14% 10%)", duration: 1.15, ease: "power3.inOut" },
          0.05
        )
        .from(".hero-frame img", { scale: 1.12, duration: 1.35, ease: "power3.out" }, 0.05)
        .from(".hero-photo figcaption", { y: 10, opacity: 0, duration: 0.5 }, 0.45);

      gsap.to(".hero-frame img", {
        yPercent: 10,
        ease: "none",
        scrollTrigger: {
          trigger: el,
          start: "top top",
          end: "bottom top",
          scrub: true,
        },
      });
    }, el);

    return () => ctx.revert();
  }, []);

  return (
    <section className="hero" id="home" ref={root}>
      <div className="wrap hero-grid">
        <div className="hero-copy">
          <p className="kicker">
            <span className="kicker-mark" aria-hidden="true" />
            Sector 10A, Gurugram
          </p>
          <h1>A 25-bed hospital near Rockford School.</h1>
          <p className="lede">
            Rao Lokram Charitable Trust runs OPD every day from 9 to 5 — medicine,
            maternity, children, bones and joints, diabetes, and a laboratory that
            also collects samples at home. The rates are set for this neighbourhood.
            There is no form on this site.
          </p>
          <div className="actions">
            <a
              className="btn btn-green"
              href={`tel:${site.phoneTel}`}
              aria-label={`Call the hospital desk at ${site.phoneDisplay}`}
            >
              Call the desk
            </a>
            <a className="btn btn-line" href="#services">
              See services
            </a>
          </div>
          <ul className="fact-row">
            <li>
              <strong>25</strong>
              <span>inpatient beds</span>
            </li>
            <li>
              <strong>9–5</strong>
              <span>OPD, all week</span>
            </li>
            <li>
              <strong>Lab</strong>
              <span>on site &amp; at home</span>
            </li>
          </ul>
        </div>
        <figure className="hero-photo">
          <div className="hero-frame">
            <img
              src={withBase("/images/campus/care-1.jpg")}
              alt="A clinician at Rao Lokram Charitable Trust consulting a patient in the OPD room"
              width="1200"
              height="900"
            />
          </div>
          <figcaption>OPD room, Anaj Mandi Chowk. Ask for the desk when you arrive.</figcaption>
        </figure>
      </div>
    </section>
  );
};

export default Home;
